export default __webpack_public_path__ + "static/no-image_baseball-a54a880c4e9c0fe3145d00c8e5ad342e.png";